exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".providers-list-page .b-tabs{margin-top:20px}.providers-list-page .card.card-monitor-component{max-width:288px}.providers-list-page .tabs li{width:33.3333333333%}.providers-list-page .tabs li a{font-weight:bold}.providers-list-page .tabs li.is-active a{border-bottom-color:#36f;color:#36f}", ""]);

// exports
